export default __webpack_public_path__ + "static/media/negative.c0d6cebb.png";